export default "{\n    \"today\": \"Hoy\"\n}\n"